module.exports = __webpack_public_path__ + "gemini-9d8c808e1e94a83dbc51.png";